import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../utils/types/api-response";
import { sendStatementOfAccount } from "../services/statement-of-account.services";
import { IStatementOfAccountFilters } from "../types/statement-of-account.types";

// Hook to send clients statement of account
export function useSendStatementOfAccount(filters: IStatementOfAccountFilters) {
    return useMutation<
        IApiResponse<{ message: string }>,
        AxiosError<IApiResponse<{ message: string }>>,
        null
    >({
        mutationKey: ["send-statement"],
        mutationFn: () => sendStatementOfAccount(filters),
    });
}
